<script setup lang="ts">
// Data
defineProps({
  type: {
    type: String,
    required: true,
  },
})
</script>

<template>
  <Button
    size="small"
    severity="info"
    outlined
  />
</template>
